export enum InfrastructureStatusColorEnum {
    INFRST_UNKNOWN = 'medium',
    INFRST_COORDINATION_REQUIRED  = 'success',
    INFRST_COORDINATION_NOT_REQUIRED = 'queenblue',
    INFRST_COORDINATION_RESTRICTIVE = 'warning',
    INFRST_PERMANENTLY_CLOSED = 'medium',

    INFRST_PARTIALLY_BLOCKED = 'orangered',
    INFRST_BLOCKED = 'danger',
}